// Small conversions between protobuf enums and the plain view types of the HUD / renderer.

import type { BotLevel, HudMode, MatchPhase as HudPhase, TeamTag } from "../hud/types";
import { BotDifficulty, GameMode, MatchPhase, Team } from "../proto/gunrun/v1/common_pb";

export function teamTag(t: Team): TeamTag {
  return t === Team.A ? "a" : t === Team.B ? "b" : "none";
}

/** The level of a bot as the HUD shows it; `null` for a human (`isBot` false). */
export function botLevel(isBot: boolean, d: BotDifficulty): BotLevel | null {
  if (!isBot) return null;
  return d === BotDifficulty.EASY ? "easy" : d === BotDifficulty.HARD ? "hard" : "normal";
}

export function botDifficulty(level: BotLevel): BotDifficulty {
  return level === "easy" ? BotDifficulty.EASY : level === "hard" ? BotDifficulty.HARD : BotDifficulty.NORMAL;
}

export function hudMode(m: GameMode): HudMode {
  switch (m) {
    case GameMode.TDM:
      return "tdm";
    case GameMode.KOTH:
      return "koth";
    case GameMode.DEFUSAL:
      return "defusal";
    default:
      return "ffa";
  }
}

export function hudPhase(p: MatchPhase): HudPhase {
  switch (p) {
    case MatchPhase.COUNTDOWN:
      return "countdown";
    case MatchPhase.LIVE:
      return "live";
    case MatchPhase.ROUND_FREEZE:
      return "round_freeze";
    case MatchPhase.ROUND_LIVE:
      return "round_live";
    case MatchPhase.ROUND_END:
      return "round_end";
    case MatchPhase.ENDED:
      return "ended";
    default:
      return "warmup";
  }
}

export function isTeamMode(mode: HudMode): boolean {
  return mode !== "ffa";
}

/** Rotates a world-space direction into an angle relative to the view yaw (0 = ahead, + = left). */
export function relativeBearing(dx: number, dz: number, viewYaw: number): number {
  // forward(yaw) = (-sin yaw, -cos yaw): the yaw that looks along (dx, dz) is atan2(-dx, -dz).
  const target = Math.atan2(-dx, -dz);
  let r = target - viewYaw;
  r -= 2 * Math.PI * Math.floor((r + Math.PI) / (2 * Math.PI));
  return r;
}
